'use client'

import React, { useEffect, useState } from 'react'
import Icon from '@dustin-web/microsite-components/src/icon'
import FooterNewsletterSwitcher from './footer-newsletter-switcher'
import { useTranslations, useSiteContext } from '@dustin-web/microsite-components/src/hooks'
import { TextSkeleton, Skeleton } from '@dustin-web/microsite-components/src/skeleton'
import throttle from 'lodash/throttle'
import { injectGatherFormScript } from '../../3rd-party-scripts/gather-form-script'

const FooterNewsletterSignup = () => {
  const { translate } = useTranslations()
  const [newsletterShow, setNewsLetterShow] = useState(false)
  const { site } = useSiteContext()
  const [showSkeleton, setShowSkeleton] = useState(true)
  const [initLock, setInitLock] = useState(true)

  // make sure GTM-script has loaded
  useEffect(() => {
    const newsLetterSetTimeout = setTimeout(() => {
      setInitLock(false)
    }, 2000)
    return () => clearTimeout(newsLetterSetTimeout)
  }, [])

  useEffect(() => {
    if (!newsletterShow) {
      const handleScroll = throttle(() => {
        const footer = document.querySelector('#footer') as HTMLElement | null
        const footerOffsetTop = footer?.getBoundingClientRect().top ?? 0
        const viewportHeight = window.innerHeight

        // arbitrary number to trigger scroll a bit sooner, but still defer until you are about to reach the footer
        if (footerOffsetTop < viewportHeight + 500) {
          setNewsLetterShow(true)
          window.removeEventListener('scroll', handleScroll)
        }
        /* onRenderFinished is the callback for the form load in the script that loads the newsletter signup form.
        /* its used to handle the gap between skeleton screen and form load time */
        // @ts-ignore
        window.onRenderFinished = () => {
          setShowSkeleton(false)
        }
      }, 1000)

      handleScroll()

      window.addEventListener('scroll', handleScroll)

      return () => {
        window.removeEventListener('scroll', handleScroll)
      }
    }
  }, [newsletterShow])

  useEffect(() => {
    if (newsletterShow && !initLock) {
      injectGatherFormScript()
    }
  }, [newsletterShow, initLock])

  return (
    <div className="newsletter-section">
      <div className="content-area-input u-mb-12 u-mb-lg-0">
        <p className="u-color-gray-02 d-flex flex-row u-mb-6 h2">
          <Icon name="email" className="i-white i-32 u-mr-12" />
          <span>{translate('UpdateHeadline_Newsletter')}</span>
        </p>
        <p className="u-color-gray-02 u-mb-16">{translate('UpdateBreadText_Newsletter')}</p>
      </div>
      <div className="content-area-input u-mb-lg-0">
        {showSkeleton && (
          <div style={{ maxWidth: '428' }}>
            <Skeleton height={40} shade={'light-on-dark-bg'} className="u-mb-32" />
            <TextSkeleton type={'p'} shade={'light-on-dark-bg'}></TextSkeleton>
            <TextSkeleton type={'p'} shade={'light-on-dark-bg'}></TextSkeleton>
          </div>
        )}
        {newsletterShow && !initLock && (
          <div className="row">
            <FooterNewsletterSwitcher site={site} />
          </div>
        )}
      </div>
    </div>
  )
}

export default FooterNewsletterSignup
